'use client'

import Image from 'next/image'
import { Link, usePathname } from '@/navigation'

import EyeIcon from '@/components/icons/Eye'

import type { FC } from 'react'
import type { INewsData } from '@/types'

const ArticlesCard: FC<INewsData> = (data) => {
  const pathname = usePathname()
  const isArticlesPage = pathname === '/articles'

  return (
    <Link href={'/articles/' + data.slug}>
      <div className="flex h-full flex-col rounded-xl border border-secondary-light bg-white p-4 duration-200 hover:border-primary">
        <div
          className={`mb-6 overflow-hidden rounded-lg ${
            isArticlesPage ? 'h-[195px]' : 'h-[277px]'
          }`}
        >
          <Image
            src={data.image}
            alt={data.title}
            width={328}
            height={277}
            className="h-full w-full object-contain"
          />
        </div>
        <div className="flex flex-1 flex-col">
          <h5 className="mb-2 line-clamp-2">{data.title}</h5>
          {!isArticlesPage && (
            <p className="mb-4 line-clamp-3 flex-1 text-secondary-dark">{data.short_desc}</p>
          )}
        </div>
        <div className="flex flex-row justify-between text-sm text-secondary">
          <span>{data.published}</span>
          <span className="flex flex-row items-center gap-1">
            <span className="text-base">
              <EyeIcon />
            </span>
            <span>{data.viewer}</span>
          </span>
        </div>
      </div>
    </Link>
  )
}

export default ArticlesCard
